import React from 'react';

const Home = () => {
    return (
        <div>
            <h2>Start managing your tasks today!</h2>
            <p>This website is built to help you manage your daily tasks.</p>
        </div>
    );
}

export default Home;
